import { render, staticRenderFns } from "./TefBines.vue?vue&type=template&id=a2f1caa4&"
import script from "./TefBines.vue?vue&type=script&lang=js&"
export * from "./TefBines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports